import React, { useState } from 'react';
import { Check } from 'lucide-react';
import Card from '../common/Card';
import { formatCurrency } from '../../utils/formatters';

const FALLBACK_IMAGE = '/images/wreaths/placeholder.svg';

const WreathCard = ({ wreath, onClick, isInCart = false }) => {
  const [imgError, setImgError] = useState(false);

  const getCategoryBadgeColor = (category) => {
    switch (category) {
      case '프리미엄':
        return 'bg-primary text-white';
      case '스탠다드':
        return 'bg-accent-400 text-primary';
      case '이코노미':
        return 'bg-accent-200 text-accent-800';
      default:
        return 'bg-accent-200 text-accent-800';
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <Card
      hover
      padding="none"
      onClick={onClick}
      className="overflow-hidden h-full flex flex-col focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
    >
      <div
        role="button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
        aria-label={`${wreath.name} 상세 보기`}
        className="h-full flex flex-col"
      >
        {/* 화환 이미지 */}
        <div className="relative aspect-square w-full overflow-hidden bg-accent-100">
          <img
            src={imgError ? FALLBACK_IMAGE : wreath.image}
            alt={wreath.name}
            loading="lazy"
            onError={() => setImgError(true)}
            className="w-full h-full object-cover"
          />

          {/* 카테고리 배지 */}
          <div className="absolute top-3 left-3">
            <span
              className={`
                px-3 py-1 rounded-full text-sm font-medium shadow-md
                ${getCategoryBadgeColor(wreath.category)}
              `}
            >
              {wreath.category}
            </span>
          </div>

          {/* 담김 표시 */}
          {isInCart && wreath.inStock && (
            <div className="absolute top-3 right-3">
              <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-green-600 text-white shadow-md">
                <Check size={12} />
                담김
              </span>
            </div>
          )}

          {/* 품절 표시 */}
          {!wreath.inStock && (
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <span className="bg-red-600 text-white px-4 py-2 rounded-lg font-bold text-lg">
                품절
              </span>
            </div>
          )}
        </div>

        {/* 화환 정보 */}
        <div className="p-4 flex-1 flex flex-col">
          <h3 className="text-lg font-bold text-primary mb-2 line-clamp-2">
            {wreath.name}
          </h3>

          <p className="text-sm text-accent-600 mb-3 line-clamp-2 flex-1">
            {wreath.description}
          </p>

          {/* 가격 */}
          <div className="flex items-center justify-between mt-auto pt-3 border-t border-accent-200">
            <span className="text-2xl font-bold text-primary">
              {formatCurrency(wreath.price)}
            </span>

            {wreath.inStock ? (
              <span className="text-sm text-accent-600 font-medium">구매 가능</span>
            ) : (
              <span className="text-sm text-red-500 font-medium">품절</span>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default WreathCard;
